import { FormErrors } from '../modules/FormErrors';
import { Sidebar } from '../modules/Sidebar';

class SendCartSidebar {
    constructor() {
        if (typeof ajax === 'undefined') {
            return;
        }

        this.sidebar = new Sidebar({
            overlayClassNames: ['bg-grey-900/60'],
        });
        this.contentHost = document.createElement('div');
        this.contentHost.className = 'h-full w-full max-w-[720px]';
        this.sidebar.content.appendChild(this.contentHost);
        this.isLoading = false;
        this.submitDefaultLabel = '';

        document.addEventListener('click', this.onDocumentClick.bind(this), true);
        this.sidebar.content.addEventListener('submit', this.onSidebarSubmit.bind(this));
    }

    async onDocumentClick(event) {
        const trigger = event.target.closest('[data-open-send-cart-sidebar]');

        if (!trigger) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (
            window.mdaMinicart?.sidebar?.root?.classList.contains('-active')
        ) {
            window.mdaMinicart.sidebar.close();
        }

        await this.open();
    }

    async open() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.contentHost.innerHTML =
            '<div class="send-cart-sidebar flex h-full w-full max-w-[720px] items-center justify-center bg-background-primary"><p class="text-1614! text-text-secondary">Ładowanie...</p></div>';

        try {
            const html = await this.fetchSidebarHtml();

            if (!html) {
                return;
            }

            this.applySidebarHtml(html);
            this.sidebar.open();
        } finally {
            this.isLoading = false;
        }
    }

    async fetchSidebarHtml() {
        const formData = new FormData();
        formData.append('action', 'mda_send_cart_sidebar');
        formData.append('nonce', ajax.nonce);

        const response = await fetch(ajax.url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });

        if (!response.ok) {
            return null;
        }

        const result = await response.json();

        if (!result?.success || typeof result?.data?.html !== 'string') {
            return null;
        }

        return result.data.html;
    }

    applySidebarHtml(html) {
        this.contentHost.innerHTML = html;
        this.initForm(this.contentHost);
    }

    getSubmitButtonLabelElement(button) {
        return button?.querySelector('.button-animation__content') || button;
    }

    initForm(root) {
        const form = root.querySelector('[js-send-cart-form]');

        if (!form) {
            return;
        }

        const submitButton = form.querySelector('[js-send-cart-submit]');
        const submitLabel = this.getSubmitButtonLabelElement(submitButton);

        if (submitLabel) {
            this.submitDefaultLabel = submitLabel.textContent.trim();
        }
    }

    async onSidebarSubmit(event) {
        const form = event.target.closest('[js-send-cart-form]');

        if (!form || !this.contentHost.contains(form)) {
            return;
        }

        event.preventDefault();

        const formErrors = new FormErrors(form);
        const loader = form.querySelector('.loader');
        const submitButton = form.querySelector('[js-send-cart-submit]');
        const submitLabel = this.getSubmitButtonLabelElement(submitButton);
        const output = this.contentHost.querySelector('[js-send-cart-output]');
        const outputIcon = output?.querySelector('[js-send-cart-output-icon]');
        const outputMessage = output?.querySelector('[js-send-cart-output-message]');
        const emailInput = form.querySelector('[name="email"]');
        const email = emailInput?.value?.trim() || '';

        formErrors.clearErrors();

        if (!email) {
            formErrors.handleFieldError(
                emailInput,
                true,
                'Podaj poprawny adres e-mail.'
            );
            return;
        }

        if (loader) {
            loader.classList.add('active');
        }

        if (submitButton) {
            submitButton.disabled = true;
        }

        if (submitLabel) {
            submitLabel.textContent = 'Wysyłanie...';
        }

        try {
            const formData = new FormData();
            formData.append('action', 'mda_send_cart_email');
            formData.append('nonce', ajax.nonce);
            formData.append('email', email);

            const response = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });

            const result = await response.json();
            const message = result?.data?.message || '';
            const fields = result?.data?.fields || null;

            if (!result?.success) {
                if (fields?.email && emailInput) {
                    formErrors.handleFieldError(emailInput, true, fields.email);
                    return;
                }

                this.showOutput(output, outputIcon, outputMessage, 'error', message);
                return;
            }

            form.classList.add('hidden');
            this.showOutput(output, outputIcon, outputMessage, 'success', message);

            if (result?.data?.cart_cleared && window.mdaMinicart?.markCartDirty) {
                window.mdaMinicart.markCartDirty();
            }
        } catch (error) {
            console.error(error);
            this.showOutput(
                output,
                outputIcon,
                outputMessage,
                'error',
                'Nie udało się wysłać koszyka. Spróbuj ponownie za chwilę.'
            );
        } finally {
            if (loader) {
                loader.classList.remove('active');
            }

            if (submitButton) {
                submitButton.disabled = false;
            }

            if (submitLabel) {
                submitLabel.textContent = this.submitDefaultLabel || 'Wyślij koszyk';
            }
        }
    }

    showOutput(output, outputIcon, outputMessage, status, message) {
        if (!output || !outputIcon || !outputMessage) {
            return;
        }

        output.classList.remove('-success', '-error');
        output.classList.add(`-${status}`);
        outputIcon.classList.remove('icon-check', 'icon-close');
        outputIcon.classList.add(status === 'success' ? 'icon-check' : 'icon-close');
        outputMessage.textContent = message;
    }
}

new SendCartSidebar();
